import { Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { InvestmentsColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/InvestmentsColumns";
import { DiscretePerformanceType } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/DiscretePerformanceType";
import { ITableConfig } from "../../../../../../../Shared/Table/Table";
import * as React from "react";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";

export class Contents {
    //Investment pop up model
    public static InvestmentInfoTitle = "Investment information";
    public static InvestmentPriceHistory = "Price history";
    public static Aims =
        "The objective is to produce capital growth over the long term.The Sub-fund will invest principally in equities of companies which are listed, quoted, traded, incorporated, domiciled or conducting a significant portion of their business in the United States of America. Such investment may be direct or indirect and the portfolio will be concentrated.The Sub-fund may also invest in other equities, cash, and near cash. Up to (but no more than) 10% in value of the Sub-fund may be invested in each of the following: (1) collective investment schemes, including those managed or operated by the ACD and (2) deposits.The Sub-fund will be actively managed and investment may be made in any economic sector.";
    public static CumulativePerformance = "Cumulative performance";
    public static DiscretePerformance = "Discrete performance";
    public static InvestmentUnitCost = "Your average unit cost";
    public static InvestmentUnitPriceAt = "Unit price";
    public static InvestmentUnitCostTooltip = "This is a tooltip for average unit cost";
    public static InvestmentUnitAsAt = "as at ";
    public static InvestmentFactSheet = "Fund Factsheet";
    public static InvestmentKIDD = "KID/KIID";
    public static InvestmentSCFD = "Consumer Facing Disclosure";
    public static NoticeTopContent = "Important Notice relating to investor information documents for MUTUAL FUNDS: ";
    public static NoticeContent =
        "These documents are provided by third parties to inform investment decisions. Aberdeen group is not responsible for these documents*, has not reviewed them and accepts no liability in connection width your use of them or any of their content.These documents display the fund manager's standard retail charges and please note that product charges may replace the charges displayed. For further information, please refer to the Investment Guide for the relevant product.";
    public static NoticeBottomContent =
        "*Excluding Aberdeen Investments KIIDS/Fund Factsheets or any other Aberdeen group produced investment documentation such as KIDs or SIDs.";
    public static FactSheetUrl = "https://webfund6.financialexpress.net/clients/standardlife/fundfactsheet.aspx?code=";
    public static ErrorMessage_FileFailedToOpen = "Failed to open KID/KIDD document";
    public static NonUKDomicileWarning =
        "The following disclosure is applied to all overseas domiciled products regardless of whether the product uses any sustainable related terms in it's name, marketing, product features or content - This product is based overseas and is not subject to UK sustainable investment labelling and disclosure requirements.";
    public static NotUKDomicileWarning = "This product is based overseas and is not subject to UK sustainable investment labelling and disclosure requirements";
}
export const DiscretePerforamnceTypeDic: Dictionary[] = [
    { key: DiscretePerformanceType.M1, value: "1m" },
    { key: DiscretePerformanceType.M3, value: "3m" },
    { key: DiscretePerformanceType.M6, value: "6m" },
    { key: DiscretePerformanceType.Y1, value: "1y" },
    { key: DiscretePerformanceType.Y3, value: "3y" },
    { key: DiscretePerformanceType.Y5, value: "5y" },
];

export const InvestmentsColConfig = (onEditTreasure?: () => void): ITableConfig[] => {
    return [
        { title: "Investments", tableFilter: InvestmentsColumns.Investments, filterOption: { disableEdit: true } },
        { title: "Allocation", tableFilter: InvestmentsColumns.Allocation, filterOption: { disableEdit: true } },
        { title: "Target allocation", tableFilter: InvestmentsColumns.TargetAllocation },
        { title: "Fund code", tableFilter: InvestmentsColumns.FundCode },
        { title: "Quantity", tableFilter: InvestmentsColumns.Quantity, filterOption: { disableEdit: true } },
        { title: "Location", tableFilter: InvestmentsColumns.Location },
        { title: "Unit cost", tableFilter: InvestmentsColumns.UnitCost, filterOption: { disableEdit: true } },
        { title: "Unit price", tableFilter: InvestmentsColumns.UnitPrice, filterOption: { disableEdit: true } },
        { title: "Total cost", tableFilter: InvestmentsColumns.TotalCost, filterOption: { disableEdit: true } },
        { title: "Market value", tableFilter: InvestmentsColumns.MarketValue, filterOption: { disableEdit: true } },
        { title: "Difference", tableFilter: InvestmentsColumns.Difference, filterOption: { disableEdit: true } },
        {
            title: (
                <p className="mb-0">
                    Protect
                    {onEditTreasure && (
                        <span>
                            <button
                                className="edit-circle-icon-button label-sr-only"
                                disabled={!checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)}
                                onClick={() => onEditTreasure()}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="text">Edit treasure assets</span>
                            </button>
                        </span>
                    )}
                </p>
            ),
            tableFilter: InvestmentsColumns.TreasuredAsset,
            filterOption: { disableEdit: false },
        },
    ];
};
